import { DataSource, Label, Layout, Panel, ReportPreviewTabSource, Tab } from "@mcleod/components";
import { ArrayUtil, Currency, CurrencySettings, CurrencyUtil, DisplayType } from "@mcleod/core";
import { InvoiceProcessingExceptionTable } from "./reports/InvoiceProcessingExceptionTable";
import { ImageName } from "@mcleod/images";

export class MiscInvoiceProcessingUtil {
    static createExceptionTab(exceptionList: any[]): Tab | null {
        if (ArrayUtil.isEmptyArray(exceptionList)) {
            return null;
        }
        const layoutExceptionTable =
            Layout.getLayout("lme/ar/reports/InvoiceProcessingExceptionTable") as InvoiceProcessingExceptionTable;
        layoutExceptionTable.addLayoutLoadListener(() => {
            layoutExceptionTable.data = exceptionList;
        });
        const tab = new Tab({ components: [ layoutExceptionTable ], caption: "Exceptions" });
        tab.imageName = ImageName.triangleWarning;
        tab.imageColor = "error";
        return tab;
    }

    static cleanTabSources(tabSources: ReportPreviewTabSource[]): ReportPreviewTabSource[] {
        return tabSources.filter(data => data != null);
    }

    static populateMulticurrencyTotals(dataSource: DataSource, totalsPanel: Panel, multicurrencyTotals: any[]) {
        totalsPanel.removeAll();
        if (!CurrencySettings.getSingleton().multiCurrencyEnabled() || ArrayUtil.isEmptyArray(multicurrencyTotals)) {
            return;
        }

        // Populate the totalsPanel with multicurrency totals
        multicurrencyTotals.forEach(total => {
            const amount = new Currency({ ...total?.invoice_amount as Currency });
            const count = total?.invoice_count || "0";
            const currencyPanel = new Panel({
                id: "panelCurrencyTotal" + amount.getCurrencyCode(),
                width: 150,
                paddingLeft: 0,
                rowBreak: false
            });

            const currencyTypeCountLabel = new Label({
                id: "labelCurrencyTypeCount" + amount.getCurrencyCode(),
                rowBreak: true,
                text: amount.getCurrencyCode() + ": " + count,
                color: "subtle.darker",
                fontBold: true
            });

            const currencyAmountLabel = new Label({
                id: "labelCurrencyAmount" + amount.getCurrencyCode(),
                rowBreak: true,
                dataSource: dataSource,
                field: "invoice_amount_" + amount.getCurrencyCode().toLowerCase(),
                displayType: DisplayType.CURRENCY,
                text: CurrencyUtil.formatCurrency(amount),
                color: "subtle.darker",
                fontBold: true
            });

            currencyPanel.add(currencyTypeCountLabel);
            currencyPanel.add(currencyAmountLabel);
            totalsPanel.add(currencyPanel);

            dataSource.activeRow?.updateCurrency("invoice_amount_" + amount.getCurrencyCode().toLowerCase(), amount);
        });
    }
}
